import styled from 'styled-components';
import { BLACK } from '../../constants/colors';

export const boughtChartStyle = (component) => styled(component)``;

export const boughtChartTooltipStyle = (component) => styled(component)`
  ${(props) => {
    return props.theme.graph.baseFontStyle;
  }}
  color: ${BLACK};
  margin: 6px 8px;
  .tooltip_heading {
    text-transform: capitalize;
    font-size: 13px;
    margin-bottom: 3px;
  }
  .tooltip_value {
    min-width: 145px;
    > div {
      margin-bottom: 3px;
    }
  }
`;
